<header>
  <div class="logo">
    <img src="/LogoALAsso.png" alt="logo A l'asso!" [routerLink]="'/'" />
    <h1 id="header-title">a l'asso !</h1>
  </div>

  <div class="right-side-container">
    @if (userInfos$ | async; as userInfo) {
      @if (userInfo.isConnected) {
        @if (userInfo.canPublishActivity && !isOnActivityCreationPage()) {
          <app-single-button
            class="underline-animate"
            [type]="'button'"
            [id]="'create-activity-btn'"
            [routerLink]="['/activity', 'creation']"
            routerLinkActive="active"
            [styleClass]="ButtonStyleClass.addActivityButton"
            [label]="'Publier une activité'"
            [ariaLabel]="'button de navigation vers la page de creation des activités'">
          </app-single-button>
        }

        <div class="user-info">
          <p class="user-name" @fadeInOut>Bonjour, {{ userInfo.userDisplayName }} !</p>
          <app-header-menu></app-header-menu>
        </div>
      } @else {
        <div class="auth-buttons">
          <button class="inscription-btn" type="button" (click)="openRegisterModal()">S'inscrire</button>
          <button id="connexion-btn" class="connexion-btn" type="button" (click)="handleLoginModal(true)">Se connecter</button>
        </div>
      }
    }
  </div>
</header>
<app-register-modal [(visible)]="showRegisterModal"></app-register-modal>
<app-login-modal [email]="email" [(visible)]="showLoginModal" (openPasswordForgottenModal)="openPasswordForgottenModal()"></app-login-modal>
<app-forgot-password-modal [(visible)]="showPasswordForgottenModal" (closeLoginModal)="closeLoginModal()"></app-forgot-password-modal>
